
import Button from '../../../components/base/Button';

export default function BusinessPillars() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Core Business Pillars
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Twin Towers bridges Korean beauty innovation with global markets through two strategic business divisions
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Pillar 1 - Global Brand Distribution */}
          <div 
            id="brands"
            className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            onClick={() => window.open('https://www.celina226.com', '_blank')}
          >
            <div 
              className="h-64 bg-cover bg-center relative"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/40b0e54abc8a92bbb8d049c8a84106ef/2dac9997e38a62e2b803847d7db26917.jpeg')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <h3 className="text-2xl font-bold text-white mb-2">Global Brand Distribution</h3>
              </div>
            </div>
            
            <div className="p-8">
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                Authorized K-Beauty Distribution & Sales
              </h4>
              
              <p className="text-lg font-medium text-[#C8A654] mb-4">
                Bridging Asia to the World: Official Brand Partnerships
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Golden Twin Towers (GTT Ltd.) connects innovative Korean beauty brands with major distributors and retailers across the UK, Europe, and the Middle East (MENA). As the exclusive partner of Celina Co., Ltd., we distribute high-demand K-Beauty lines such as Minicell, ensuring authenticity, compliance, and efficient logistics.
              </p>
              
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-[#C8A654]/10 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-chat-3-fill text-[#C8A654]"></i>
                </div>
                <span className="font-medium text-gray-900">UK/EU/MENA Market Entry Experts</span>
              </div>
              
              <Button className="w-full group-hover:bg-[#B8964A]">
                <i className="ri-external-link-line mr-2"></i>
                Visit Celina Website
              </Button>
            </div>
          </div>

          {/* Pillar 2 - OEM/ODM Services */}
          <div 
            id="oem-odm"
            className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            onClick={() => window.open('https://www.natuzen.net', '_blank')}
          >
            <div 
              className="h-64 bg-cover bg-center relative"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/40b0e54abc8a92bbb8d049c8a84106ef/ee44c04cfbc7fef36846f59304d0e1da.png')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <h3 className="text-2xl font-bold text-white mb-2">Premium OEM/ODM Services</h3>
              </div>
            </div>
            
            <div className="p-8">
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                K-Factory Manufacturing & Product Development
              </h4>
              
              <p className="text-lg font-medium text-[#C8A654] mb-4">
                Powered by Natuzen: Seamless OEM/ODM Solutions
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Through our partnership with Natuzen Co., Ltd. (www.natuzen.net), a CGMP- and ISO-certified manufacturer in South Korea, GTT provides a full range of OEM/ODM services—from concept development and R&D to global export. We make your cosmetic vision come to life with precision, speed, and compliance.
              </p>
              
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-[#C8A654]/10 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-chat-3-fill text-[#C8A654]"></i>
                </div>
                <span className="font-medium text-gray-900">Advanced R&D & Quality Assurance</span>
              </div>
              
              <Button className="w-full group-hover:bg-[#B8964A]">
                <i className="ri-external-link-line mr-2"></i>
                Visit Natuzen Website
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
